import {mergeProperties, reverseEnum} from "../components/Utility";
import {Status} from "../enums/enums"
export const  getFormData = (data) => {
    const initialData = {
        id: "",
        name: '',
        foodLicense: '',
        regId: "",
        status: "",
        image: "",
        description: '',
    }
    // fill data in initialData from data
    return mergeProperties(initialData, data);
};



export const getTableColumns = ({ActionDropdown,deleteHandler,Stack}) => {
    let tableColumns = [
        { header: "Name", field: "name" },
        { header: "Food License", field: "foodLicense" },
        { header: "Reg Id", field: "regId" },
        { header: "Status", field: "status" },
    ];

    tableColumns.push({
        header: 'Action',
        disableSorting: true,
        field: 'action',
        align: "right",
        render: (row) => {
            return <ActionDropdown row={row} owners={true} user={true} onDelete={deleteHandler}/>;
        },
    });

    return tableColumns;
};


export const getTableData  = ({items = []}) => {
    if (!Array.isArray(items)) return [];
    return items.map(item => ({
        id: item.id,
        name: item.name,
        description: item.description,
        foodLicense: item.foodLicense,
        regId: item.regId,
        status: reverseEnum(Status)[item.status]
    }));
}

export const getDetailData = ({item}) => {
    if (!item) return { details: {} };
    return {
        details: {
            name: item?.name,
            image: item?.image,
            foodLicense: item?.foodLicense,
            regId: item?.regId,
            status: reverseEnum(Status)[item?.status],
            branches: item.owners && item.branches.map(branch => (`${branch.name} (${branch.branchType})`)).join(', '),
            owners: (
                <ul className="list-unstyled mb-0">
                    {item.owners && item.owners.map((owner, idx) => (
                        <li key={idx} className="mb-3 p-2 border rounded-3">
                            Name: {owner.fullName}<br />
                            Phone: {owner.phone}<br />
                            Percentage: {owner.stakePercentage}%
                        </li>
                    ))}
                </ul>
            ),
            admins: (
               <>
                   {item?.admins && item.admins.length > 0 ? (
                       <ul className="list-unstyled mb-0">
                           {item.admins.map((owner, idx) => (
                               <li key={idx} className="mb-3 p-2 border rounded-3">
                                   Name: {owner.fullName}<br />
                                   Phone: {owner.phone}<br />
                               </li>
                           ))}
                       </ul>
                   ) : (
                       <p>--</p>
                   )}
               </>
            ),
            description: item?.description,
        }
    };
}
